module.exports = __webpack_public_path__ + "img/IMG_0913.79004160.jpg";